// Theme utility functions
export const applyThemeColors = (colors: { [key: string]: string }) => {
  Object.entries(colors).forEach(([property, value]) => {
    document.documentElement.style.setProperty(property, value);
  });
};

export const getThemeColors = (colors: { light: { [key: string]: string }, dark: { [key: string]: string } }, isDark: boolean) => {
  return isDark ? colors.dark : colors.light;
};

export const isDarkMode = (): boolean => {
  // Check localStorage first, then fallback to body class
  const savedTheme = localStorage.getItem("themeMode");
  if (savedTheme) {
    return savedTheme === "dark";
  }
  return document.body.classList.contains("dark");
};

export const setDarkMode = (isDark: boolean) => {
  if (isDark) {
    document.body.classList.add("dark");
    localStorage.setItem("themeMode", "dark");
  } else {
    document.body.classList.remove("dark");
    localStorage.setItem("themeMode", "light");
  }
};

export const getStoredThemeMode = (): boolean => {
  const savedTheme = localStorage.getItem("themeMode");
  if (savedTheme) {
    return savedTheme === "dark";
  }
  // Default to light mode if no preference is stored
  return false;
}; 